import { Box, Modal, Typography } from "@mui/material";
import React, { useContext } from "react";
import { RewardSettingContext } from "../../../contexts/RewardSettingContext";
import module from "./ConfirmModal.module.css";

const ConfirmModal = () => {
  const { pageStatus, handleModal, formInput } =
    useContext(RewardSettingContext);

  const { modalOpen, isInputted } = pageStatus;
  if (!modalOpen) return null;

  return (
    <Modal open={modalOpen} onClose={handleModal.close}>
      <div className={module.content}>
        <div>
          <h3 className={module.title}>
            下記で{`${isInputted ? "更新" : "保存"}しますか？`}
          </h3>
        </div>
        <div>
          <div></div>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmModal;
